// extracted by mini-css-extract-plugin
export var container = "_62-0";
export var fallback = "_62-5";
export var fallbackIcon = "_62-6";
export var hidden = "_62-2";
export var image = "_62-3";
export var loaded = "_62-4";
export var placeholder = "_62-1";